

/*
 * author: Michael Bauer (Geoplex)
 * email:  michael.bauer@geoplex.com.au
 *
 */

import { subclass, property } from "@arcgis/core/core/accessorSupport/decorators";
import Widget from "@arcgis/core/widgets/Widget";
import { tsx } from "@arcgis/core/widgets/support/widget";
import { getLocalConfigList, applyConfig, saveCurrentState, deleteState } from "./config"

import { appConfig } from "./main"

const CSS = {
    base: "presetpanel"
};

@subclass("esri.widgets.PresetPanel")
class PresetPanel extends Widget {

    @property()
    configIds: string[] = []

    constructor(params: any) {
        super(params);
        this.saveState = this.saveState.bind(this)
        this.loadState = this.loadState.bind(this)
        this.deleteState = this.deleteState.bind(this)
    }

    postInitialize() {
        getLocalConfigList().then((results) => {
            this.configIds = results
        })
    }

    updateConfigList() {
        getLocalConfigList().then((results) => {
            this.configIds = results
        })
    }

    saveState(e: any) {
        saveCurrentState($("#saveStateName").val() as string, true)
        this.updateConfigList()
    }

    loadState(e: any) {
        const name = $(e.target).attr('name');
        if(name != null)
            applyConfig(name)
    }

    deleteState(e: any) {
        const name = $(e.target).attr('name');

        if(name)
        deleteState(name).then(() => {
            this.updateConfigList()
        })
    }

    render() {
        let configHTMLObjects = []

        for (let configid of this.configIds) {

            configHTMLObjects.push(
                <div class="row row-no-margin" style="margin-top: 15px" key={configid}>
                    <div class="col-md-12">
                        <b style="margin-top: 5px;">{configid}</b>
                        <span style="float: right;">
                            <button name={configid} class="btn btn-default" onclick={this.deleteState}>
                                <span name={configid} class="esri-icon-trash" style="font-size: 20px;"></span>
                            </button>
                        </span>
                        <span style="float: right;">
                            <button name={configid} class="btn btn-default" onclick={this.loadState}>
                                <span name={configid} class="esri-icon-download"></span>&nbsp;
                                    Load
                            </button>
                        </span>
                    </div>
                </div>

            )
        }

        return (
            <div class={this.classes(CSS.base)} key="presetpanel-container">
                <div class="row row-no-margin" key="presetpanel-options">
                    <label for="saveStateName">
                        Save Current Config As:
                        <div class="input-group">
                            <input type="text" id="saveStateName" class="form-control"></input>
                            <span class="input-group-btn">
                                <button class="btn btn-default" onclick={this.saveState} type="button">
                                    <span class="esri-icon-save"></span>&nbsp;
                                    Save
                                </button>
                            </span>
                        </div>
                    </label>
                </div>

                {configHTMLObjects}
            </div>
        );
    }
}

export default PresetPanel